import { useCallback } from 'react'
import { useNavigate } from 'react-router-dom'
import { useActionMarkNotificationRead } from '../services/actionMarkNotificationRead.service'
import type { NotificationRow } from '../types/notification.types'

/**
 * Klik notifikasi = tandai dibaca (bila belum) lalu buka rute tujuannya. Kegagalan tandai-dibaca tidak menghalangi
 * navigasi — pengguna tetap sampai di dokumen yang dimaksud.
 */
export function useOpenNotification(onOpened?: () => void) {
  const navigate = useNavigate()
  const { mutateAsync } = useActionMarkNotificationRead()
  return useCallback(
    async (row: NotificationRow) => {
      if (!row.read_at) {
        try {
          await mutateAsync({ ids: [row.id] })
        } catch {
          /* tetap navigasi */
        }
      }
      onOpened?.()
      if (row.link) navigate(row.link)
    },
    [mutateAsync, navigate, onOpened]
  )
}
